import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { spinnerState } from '../../store/spinner-store/spinner.selector';

const CustomSpinner = () => {
    const loading = useSelector(spinnerState);

    return <Backdrop
        sx={{ color: '#004D99', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
            <CircularProgress color="inherit" />
    </Backdrop>
}

export default CustomSpinner;